module.exports = __webpack_public_path__ + "static/media/ico-footer-1.4c59dfec.svg";